export type VideoQuality = "high" | "low";

const highQualityConstraints = {
  video: {
    width: 1280,
    height: 720,
    facingMode: "user"
  },
  audio: true
} as MediaStreamConstraints;

type Options = {
  audioDeviceId?: string;
  videoDeviceId?: string;
};

export async function getLocalMedia(options: Options = {}) {
  console.log({ options });
  let constraints = highQualityConstraints;
  if (options.audioDeviceId) {
    constraints = {
      ...constraints,
      audio: {
        deviceId: options.audioDeviceId
      }
    };
  }
  if (options.videoDeviceId) {
    constraints = {
      ...constraints,
      video: {
        deviceId: options.videoDeviceId
      }
    };
  }
  console.log({ constraints });
  return navigator.mediaDevices.getUserMedia(constraints);
}
